import React from 'react'
import { Link } from 'gatsby'
import * as styles from './CoursesToc.module.scss'
import { TutorialIcon, BookIcon } from '@atlas-co/icons'

const CoursesToc = ({ courseSlug, lessons, active, withBg, compact }) => {
  if (!lessons || lessons.length === 0) return null

  const grouped = lessons.reduce((acc, lesson) => {
    const key =
      lesson.module ||
      (lesson.moduleOrder
        ? `Module ${lesson.moduleOrder}`
        : 'Course content')
    if (!acc[key]) acc[key] = []
    acc[key].push(lesson)
    return acc
  }, {})

  const orderedModuleKeys = Object.keys(grouped).sort((a, b) => {
    const ao = grouped[a][0]?.moduleOrder ?? 0
    const bo = grouped[b][0]?.moduleOrder ?? 0
    return ao - bo
  })

  return (
    <nav
      className={`${styles.toc} ${withBg ? styles.withBg : ''} ${
        compact ? styles.compact : ''
      }`}
      aria-label="Course contents"
    >
      <div className={styles.tocHeader}>
        <BookIcon size={24} />
        <h3>Course content</h3>
      </div>
      {orderedModuleKeys.map((moduleKey) => (
        <div key={moduleKey} className={styles.moduleBlock}>
          <div className={styles.moduleLabel}>{moduleKey}</div>
          <ul className={styles.lessonList}>
            {grouped[moduleKey].map((lesson) => {
              const isActive = active === lesson.slug
              return (
                <li key={lesson.id || lesson.slug}>
                  <Link
                    to={`/courses/${courseSlug}/${lesson.slug}/`}
                    className={`${styles.lesson} ${
                      isActive ? styles.active : ''
                    }`}
                  >
                    <span className={styles.icon}>
                      <TutorialIcon size={18} />
                    </span>
                    <span className={styles.title}>{lesson.title}</span>
                    {lesson.isLab && (
                      <span className={styles.labBadge}>Lab</span>
                    )}
                    <span className={styles.duration}>
                      {lesson.duration} min
                    </span>
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      ))}
    </nav>
  )
}

export default CoursesToc
